// extracted by mini-css-extract-plugin
export default {"custom-toaster":"index-module__custom-toaster___pQRZ5"};